// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__6q2ix","list":"BalanceDue_list__1KlnG","listRow":"BalanceDue_listRow__4yZ4t","total":"BalanceDue_total__3kdKi"};